<template>
  <BaseModal v-if="isShowing" color="grey" rounded drop-shadow>
    <section class="welcome-modal-content">
      <h1 class="welcome-modal-content__title">
        Welcome, {{ authUser.name.toUpperCase() }}!
      </h1>
      <p class="welcome-modal-content__body">
        Welcome to the “Users & Permissions” portion of your ITR onDemand user
        dashboard.
        <br />
        <br />
        You have been set as the
        <span class="welcome-modal-content--bold">Admin</span>
        for {{ authUser.company }}. This means you have permission to add and
        remove users, manage roles, manage report permissions, and more.
        <br />
        <br />
        As the new Admin for your account, you also currently have the roles
        <span class="welcome-modal-content--italic">
          "Primary Point of Contact"
        </span>
        and
        <span class="welcome-modal-content--italic">
          "Primary Data Submission Contact"
        </span>
        assigned to your account for all reports. If you would like to reassign
        these roles, and/or add secondary contacts, you can get started by
        creating new users.
      </p>
      <BaseButton
        color="primary"
        size="lg"
        class="welcome-modal-content__button"
        @click="letsGetStarted()"
      >
        LET'S GET STARTED!
      </BaseButton>
    </section>
  </BaseModal>
</template>

<script>
  import BaseModal from '~/components/base/BaseModal.vue';
  import BaseButton from '~/components/base/BaseButton.vue';

  export default {
    name: 'WelcomeModal',
    components: {
      BaseModal,
      BaseButton,
    },
    props: {
      authUser: {
        type: Object,
        required: true,
      },
    },
    data: () => ({
      isShowing: false,
    }),
    created() {
      this.isShowing = !this.authUser.has_read_welcome;
    },
    methods: {
      letsGetStarted() {
        this.isShowing = false;
        axios.post('/company-admin/user/read-welcome');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .welcome-modal-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #183961;

    &__title {
      font-size: 48px;
      font-weight: bold;
      margin: 0;
      width: 100%;
      text-align: center;
    }
    &__body {
      font-size: 16px;
      font-weight: 400;
      padding: 1rem 0;
    }
    &__button {
      padding: 4px 36px !important;
      font-size: 14px;
    }

    &--bold {
      font-weight: bold;
    }
    &--italic {
      font-style: italic;
    }
  }
</style>
